
import Vue from "vue";
import { UblDossierConfig } from "../../../plugins/ubl/models/ubl-dossier-config";
import {ISelectItem} from "winfakt-vue-components";
import {getExtraFieldKeyNames} from "@/utils/models/extra-fields";
import {ExtraFieldNamesConfig} from "@/models/dossier-configs/extra-field-names-config";
import {AuthService, BankService, DossierConfigService, DossierService, SaleService, UserConfigService} from "@/services";
import { MODULE } from "@/config/modules";
import { ModuleElectronischeFacturatie } from "@/models/dossier/module-electronische-facturatie";
import { AutoSendPeppolSettings } from "@/models/dossier/auto-send-peppol-settings";
import { BankType } from "@/models/base";
import { SaleLayoutInfo } from "@/utils/sale-layouts/sale-layout-info";

export default Vue.extend({
	data(){
		return {
			BankService,
			layouts: [] as SaleLayoutInfo[],
			autoSendPeppolSettings: new AutoSendPeppolSettings()
		};
	},
	props: {
		config: {
			type: Object as () => UblDossierConfig,
			required: true,
		}
	},
	computed: {
		layoutItems(): ISelectItem<number>[] {
			const items: ISelectItem<number>[] = [{
				text: this.$ct("default-layout").toString(),
				value: 0
			}];
			// Filter on ContactGroupID 1 (Sales/Customers)
			const saleLayouts = this.layouts.filter(l => l.ContactGroupID === 1);
			for (const layout of saleLayouts) {
				items.push({
					text: layout.Name,
					value: layout.ID
				});
			}
			return items;
		},
		extraFieldNames(): ISelectItem<string>[] {
			let t = getExtraFieldKeyNames("Text");
			let r = t.map(d => {
				return {
					text: this.extraFieldSettings[d] || d,
					value: d
				} as ISelectItem<string>;
			});
			r.unshift({
				text: this.$ct("common.empty").toString(),
				value: ""
			});
			return r;
		},
		extraFieldSettings():ExtraFieldNamesConfig{
			return DossierConfigService.getReadonlyExtraFieldNamesConfigs().ClientNames;
		},
		saleExtraFieldSettings():ExtraFieldNamesConfig{
			return DossierConfigService.getReadonlyExtraFieldNamesConfigs().SaleNames;
		},
		peppolNoteFieldItems(): ISelectItem<string>[] {
			const items: ISelectItem<string>[] = [
				{ text: this.$ct("common.empty").toString(), value: "" },
				{ text: this.$ct("peppol-note-to-print-message").toString(), value: "ToPrintMessage" },
				{ text: this.$ct("peppol-note-to-not-print-message").toString(), value: "ToNotPrintMessage" },
			];
			const textFields = getExtraFieldKeyNames("Text");
			for (const field of textFields) {
				const label = this.saleExtraFieldSettings[field] || field;
				items.push({ text: label, value: field });
			}
			return items;
		},
		peppolPoFieldItems(): ISelectItem<string>[] {
			const items: ISelectItem<string>[] = [
				{ text: this.$ct("common.empty").toString(), value: "" },
			];
			const textFields = getExtraFieldKeyNames("Text");
			for (const field of textFields) {
				const label = this.saleExtraFieldSettings[field] || field;
				items.push({ text: label, value: field });
			}
			return items;
		},
		peppolDeliveryFieldItems(): ISelectItem<string>[] {
			const items: ISelectItem<string>[] = [
				{ text: this.$ct("common.empty").toString(), value: "" },
			];
			const textFields = getExtraFieldKeyNames("Text");
			for (const field of textFields) {
				const label = this.saleExtraFieldSettings[field] || field;
				items.push({ text: label, value: field });
			}
			return items;
		},
		filteredBankTypes():BankType[] {
			let ibanInput = this.config.PeppolIban.toLowerCase().trim();
			return this.BankService.getTypes().filter(t=>{
				if (!t.Iban || !t.Bic) return false;
				return t.Iban.toLowerCase().trim().match(ibanInput) != null;
			});
		},
		bookkeeperEmail(): string {
			return this.config.BookkeeperEmailConfigs?.sales?.Email || "";
		},
		showAutoSendPeppolSettings():boolean {
			if (AuthService.wfCompany.OwnerID != AuthService.wfUser.ID && !UserConfigService.getPermissionSettings().IsAdmin) {
				return false;
			}
			let mod = AuthService.wfCompany.Modules.find(m => m.ID == MODULE.ELECTRONISCHE_FACTURATIE) as ModuleElectronischeFacturatie;
			if (!mod) return false;
			return mod.getUseWinfaktPeppol();
		},
		isDevMode():boolean {
			return process.env.NODE_ENV == "development";
		}
	},
	methods: {
		async save(){
			this.$emit("save-config");
			if (this.showAutoSendPeppolSettings) {
				const {SendSales, SendSalesFromDate} = this.autoSendPeppolSettings;
				this.autoSendPeppolSettings = await DossierService.setAutoSendPeppolSalesEnabled(SendSales, SendSalesFromDate);
			}
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
		},
		peppolIbanClicked(bank:BankType){
			this.config.PeppolIban = bank.Iban || "";
			this.config.PeppolBic =  bank.Bic || "";
		}
	},
	async created() {
		this.layouts = await SaleService.getSaleLayouts();
		if (this.showAutoSendPeppolSettings) {
			this.autoSendPeppolSettings = await DossierService.getAutoSendPeppolSettings();
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
